import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import SwitchTab from "../../components/Reusable/SwitchTab";

const TrialBalance = loadable(
  () => import("../../components/TrailBalanceGroup")
);

export default () => {
  const tabs = [
    {
      id: "trial-balance-grouped",
      label: "Trial Balance Grouped",
      href: "/accounting/trial-balance-grouped",
    },
    {
      id: "trial-balance-detail",
      label: "Trial Balance Detail",
      href: "/accounting/trial-balance-detail",
    },
  ];
  return (
    <>
      <SwitchTab tabs={tabs} />
      <div className={tw`space-y-4`}>
        <TrialBalance />
      </div>
    </>
  );
};
